const internal = require('./config.internal')
const international = require('./config.international')

module.exports = {
  internal,
  international
}
